/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { User } from '@shared/types/common';

type WithFirstAndLastName = Pick<User, 'firstName' | 'lastName'>;
type WithFirstAndLastNameAndEmail = Pick<User, 'firstName' | 'lastName' | 'email'>;
export const userFullName = (user: WithFirstAndLastName): string =>
  user ? [user.firstName, user.lastName].join(' ').trim() : '';
export const userId = (user: User): string | undefined => user?.id;
export const userFullNameOrEmail = (user: WithFirstAndLastNameAndEmail) =>
  user.firstName || user.lastName ? userFullName(user) : user.email;
